import React from "react";
import PropTypes from "prop-types";
import { Upload } from "@arco-design/web-react"; // Make sure to import Upload component
import { IconPlus } from "@arco-design/web-react/icon";

function PDFUploadForm({
  file1,
  fileName1,
  fileType1,
  file2,
  fileName2,
  fileType2,
  handleFileChange,
  documentComparison,
  handleFileRemove, 
}) {
  return (
    <>
      <div className="row br_15 scrollbar1 documentComparisionHeight  justify-content-center">
        {/* upload 1 component */}
        <div className="col-md-6">
          <div className="mb-2 d-flex justify-content-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="142"
              height="161"
              viewBox="0 0 142 161"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.11401 51.5707C8.11401 49.4107 9.86504 47.6597 12.025 47.6597H54.109C56.269 47.6597 58.02 49.4107 58.02 51.5707V67.1465H137.06C139.512 67.1465 141.5 69.1341 141.5 71.586V156.395C141.5 158.847 139.512 160.835 137.06 160.835H12.5536C10.1017 160.835 8.11407 158.847 8.11407 156.395V81.9422L8.11401 81.9213V51.5707Z"
                fill="#004C92"
              />
              <rect
                x="23.2548"
                y="0.165405"
                width="113.103"
                height="128.43"
                fill="#F6F6F6"
              />
              <rect
                x="31.9755"
                y="9.15018"
                width="95.6616"
                height="5.18445"
                fill="#E4E4E4"
              />
              <rect
                x="31.9755"
                y="26.5912"
                width="95.6616"
                height="4.22814"
                fill="#E4E4E4"
              />
              <rect
                x="31.9755"
                y="35.576"
                width="95.6616"
                height="4.22814"
                fill="#E4E4E4"
              />
              <rect
                x="31.9755"
                y="44.5608"
                width="95.6616"
                height="4.22814"
                fill="#E4E4E4"
              />
              <rect
                x="31.9755"
                y="53.5456"
                width="95.6616"
                height="4.22814"
                fill="#E4E4E4"
              />
              <rect
                x="31.9755"
                y="62.5304"
                width="95.6616"
                height="4.22814"
                fill="#E4E4E4"
              />
              <rect
                x="31.9755"
                y="71.5152"
                width="95.6616"
                height="4.22814"
                fill="#F6F6F6"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 60.6278C0 58.4678 1.75103 56.7167 3.91103 56.7167H46.0338C48.1938 56.7167 49.9449 58.4678 49.9449 60.6278L49.9449 68.3442V71.6474C49.9449 72.9887 50.6252 75.3802 53.1056 76.0077H129.54C131.991 76.0077 133.979 77.9953 133.979 80.4472V156.395C133.979 158.847 131.991 160.835 129.54 160.835H4.43955C1.98766 160.835 0 158.847 0 156.395V90.5947V80.4472V60.6278Z"
                fill="#1A82E2"
              />
              <g filter="url(#filter0_d_64_936)">
                <path
                  d="M69.1156 132.559H65.6563V111.803L56.1429 121.316L53.6868 118.86L67.386 105.161L81.0851 118.86L78.629 121.316L69.1156 111.803V132.559Z"
                  fill="white"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_64_936"
                  x="51.5727"
                  y="105.161"
                  width="31.6265"
                  height="31.6265"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="2.11407" />
                  <feGaussianBlur stdDeviation="1.05703" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_64_936"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_64_936"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <h2 className="font_15 fw-light pt-3 mb-2 text-center">
            1. Drop older version file here
          </h2>
          <h3 className="text_master2 font_15 pt-2 mb-3 text-center">
            (Word, PowerPoint, or PDF) Choose File{" "}
          </h3>
          <div className=" text-center w-100 pb-4 pb-md-0">
            {file1 ? (
              // Display the uploaded file name if a file is uploaded
              <div className="uploaded-file-info pt-2 mb-3 d-flex justify-content-center align-item-center">
                <h4 className="text_master2 font_15  text-center">{`Uploaded: ${fileName1} (${fileType1})`}</h4>  
                <i onClick={() => handleFileRemove(1)} class="ms-2 cursor-pointer fas fa-trash-alt"></i>
              </div>
            ) : (
              // Show the upload button if no file is uploaded
              <div className="arco_custom_upload">
                <Upload
                  onChange={(e) => handleFileChange(e, 1)}
                  accept=".pdf,.doc,.docx,.ppt,.pptx,.jpeg,.png,.jpg"
                >
                  <div>
                    <div className="bg_master2 px-4 br_5 py-2">
                      <div className="acro_custom_icon d-flex align-items-center justify-content-center">
                        <IconPlus />
                        <div className="text-white ms-2">Upload files</div>
                      </div>
                    </div>
                  </div>
                </Upload>
              </div>
            )}
          </div>
        </div>
        {/* upload 2 component  */}
        <div className="col-md-6">
          <div className="mb-2 d-flex justify-content-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="142"
              height="161"
              viewBox="0 0 142 161"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.11401 51.5707C8.11401 49.4107 9.86504 47.6597 12.025 47.6597H54.109C56.269 47.6597 58.02 49.4107 58.02 51.5707V67.1465H137.06C139.512 67.1465 141.5 69.1341 141.5 71.586V156.395C141.5 158.847 139.512 160.835 137.06 160.835H12.5536C10.1017 160.835 8.11407 158.847 8.11407 156.395V81.9422L8.11401 81.9213V51.5707Z"
                fill="#004C92"
              />
              <rect
                x="23.2548"
                y="0.165405"
                width="113.103"
                height="128.43"
                fill="#F6F6F6"
              />
              <rect
                x="31.9755"
                y="9.15018"
                width="95.6616"
                height="5.18445"
                fill="#E4E4E4"
              />
              <rect
                x="31.9755"
                y="26.5912"
                width="95.6616"
                height="4.22814"
                fill="#E4E4E4"
              />
              <rect
                x="31.9755"
                y="35.576"
                width="95.6616"
                height="4.22814"
                fill="#E4E4E4"
              />
              <rect
                x="31.9755"
                y="44.5608"
                width="95.6616"
                height="4.22814"
                fill="#E4E4E4"
              />
              <rect
                x="31.9755"
                y="53.5456"
                width="95.6616"
                height="4.22814"
                fill="#E4E4E4"
              />
              <rect
                x="31.9755"
                y="62.5304"
                width="95.6616"
                height="4.22814"
                fill="#E4E4E4"
              />
              <rect
                x="31.9755"
                y="71.5152"
                width="95.6616"
                height="4.22814"
                fill="#F6F6F6"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 60.6278C0 58.4678 1.75103 56.7167 3.91103 56.7167H46.0338C48.1938 56.7167 49.9449 58.4678 49.9449 60.6278L49.9449 68.3442V71.6474C49.9449 72.9887 50.6252 75.3802 53.1056 76.0077H129.54C131.991 76.0077 133.979 77.9953 133.979 80.4472V156.395C133.979 158.847 131.991 160.835 129.54 160.835H4.43955C1.98766 160.835 0 158.847 0 156.395V90.5947V80.4472V60.6278Z"
                fill="#1A82E2"
              />
              <g filter="url(#filter0_d_64_936)">
                <path
                  d="M69.1156 132.559H65.6563V111.803L56.1429 121.316L53.6868 118.86L67.386 105.161L81.0851 118.86L78.629 121.316L69.1156 111.803V132.559Z"
                  fill="white"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_64_936"
                  x="51.5727"
                  y="105.161"
                  width="31.6265"
                  height="31.6265"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="2.11407" />
                  <feGaussianBlur stdDeviation="1.05703" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_64_936"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_64_936"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <h2 className="font_15 fw-light pt-3 mb-2 text-center">
            2. Drop older version file here
          </h2>
          <h3 className="text_master2 font_15 pt-2 mb-3 text-center">
            (Word, PowerPoint, or PDF) Choose File{" "}
          </h3>
          <div className=" text-center w-100 pb-4 pb-md-0">
            {file2 ? (
              // Display the uploaded file name if a file is uploaded
              <div className="uploaded-file-info pt-2 mb-3 d-flex justify-content-center">
                <h4 className="text_master2 font_15  text-center">{`Uploaded: ${fileName2} (${fileType2})`}</h4>
                <i onClick={() => handleFileRemove(2)} class="ms-2 cursor-pointer fas fa-trash-alt"></i>
              </div>
            ) : (
              // Show the upload button if no file is uploaded
              <div className="arco_custom_upload">
                <Upload
                  onChange={(e) => handleFileChange(e, 2)}
                  accept=".pdf,.doc,.docx,.ppt,.pptx,.jpeg,.png,.jpg"
                >
                  <div>
                    <div className="bg_master2 px-4 br_5 py-2">
                      <div className="acro_custom_icon d-flex align-items-center justify-content-center">
                        <IconPlus />
                        <div className="text-white ms-2">Upload files</div>
                      </div>
                    </div>
                  </div>
                </Upload>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="mt-4">
        <button
          onClick={documentComparison}
          className="btn btn-master w-100 py-2 font_15 font_500"
        >
          Compare
        </button>
      </div>
    </>
  );
}

PDFUploadForm.propTypes = {
  handleFileRemove: PropTypes.func.isRequired,
};

export default PDFUploadForm;
